import React, { useContext } from "react";
import { Input, makeStyles } from "@material-ui/core";
import { Field, ErrorMessage } from "formik";
import FormError from "../FormError";

import FMUInputField from "./FormIkMUFormComponent/FMUInputField";
import { Typography } from "@material-ui/core";
import { viewportContext } from "../../context/ViewportContext";
import { tokens } from "../../theme/tokens";

const useStyles = makeStyles((theme) => ({
  parentChild: {
    height: "50px",
    flex: "1",
    width: "100%",
    marginRight: "20px",
    "&:nth-child(1)": {
      // paddingRight: "5vh",
    },
    "&:nth-child(2)": {
      // paddingLeft: "5vh",
    },
  },
  parentChildTallScreen: {
    height: "50px",
    flex: "1",
    width: "100%",
  },
  rowContainer: {
    display: "flex",
    marginTop: "8px",
  },
  labelContainer: {
    display: "flex",
    marginRight: "10px",
    // width: "50%",
    alignItems: "center",
    "& p": {
      fontSize: "0.8em",
      // // fontWeight:"bold",
      color: tokens.color.text.primary,
    },
  },
  fieldContainer: {
    width: "60%",
  },
  input: {
    width: "100%",
    border: `${tokens.borderWidth} solid ${tokens.color.border.default}`,
    "& .MuiInputBase-input": {
      // textIndent: "10px",
      textTransform: "capitalize",
      textAlign: "center",
      fontSize: "0.9em",
    },

    color: `${tokens.color.text.primary} !important`,
    borderRadius: tokens.radius.sm,
    height: "40px",
    // paddingLeft: "3px",
    backgroundColor: tokens.color.surface.sunken,
  },
  emailInput: {
    // width: "95%",

    border: `1px solid ${tokens.color.border.default}`,
    "& .MuiInputBase-input": {
      // textIndent: "10px",
      textAlign: "center",
      fontSize: "0.9em",
    },
    color: `${tokens.color.text.primary} !important`,
    borderRadius: tokens.radius.sm,
    height: "40px",
    // paddingLeft: "3px",
    backgroundColor: tokens.color.surface.sunken,
  },
  dateInput: {
    padding: "0px 12px",
    border: `${tokens.borderWidth} solid ${tokens.color.border.default}`,
    "& .MuiInputBase-input": {
      // textIndent: "10px",
      textAlign: "center",
      fontSize: "0.9em",
    },

    color: `${tokens.color.text.primary} !important`,
    borderRadius: tokens.radius.sm,
    height: "40px",
    // paddingLeft: "3px",
    backgroundColor: tokens.color.surface.sunken,
  },
  error: {
    fontSize: "12px",
    color: tokens.color.status.error,
    marginTop: "0.25rem",
    paddingLeft: "50%",
  },
}));
function AccountingField({
  label,
  name,
  type,
  disabled,
  placeHolder,
  isEmail,
  required,
  input,
  customOnChange,
  style,
}) {
  const { tallScreen } = useContext(viewportContext);
  const handleOnChange = (e) => {
    return customOnChange(e);
  };
  const classes = useStyles();
  return (
    <div
      className={
        tallScreen ? classes.parentChildTallScreen : classes.parentChild
      }
    >
      <div className={classes.rowContainer}>
        <div className={classes.labelContainer}>
          {required ? (
            <Typography>
              {label}
              <span style={{ color: tokens.color.status.error, fontWeight: 500 }}>*</span>
            </Typography>
          ) : (
            <Typography>{label}</Typography>
          )}
        </div>
        <div className={classes.fieldContainer}>
          {input ? (
            <Input
              name={name}
              type={type}
              disabled={disabled}
              fullwidth={"true"}
              onChange={handleOnChange}
              disableUnderline={true}
              className={
                isEmail
                  ? classes.emailInput
                  : type === "date"
                    ? classes.dateInput
                    : classes.input
              }
              // label={placeHolder ? placeHolder : label}
            />
          ) : (
            <Field
              name={name}
              type={type}
              disabled={disabled}
              fullwidth={"true"}
              style={style}
              disableUnderline={true}
              className={
                isEmail
                  ? classes.emailInput
                  : type === "date"
                    ? classes.dateInput
                    : classes.input
              }
              component={FMUInputField}
              // label={placeHolder ? placeHolder : label}
            />
          )}
        </div>
      </div>
      <div>
        <ErrorMessage
          name={name}
          component={FormError}
          className={classes.error}
        />
      </div>
    </div>
  );
}

export default AccountingField;
